import { DatePicker, Form } from 'antd'
import cls from 'classnames'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Editor } from '@/components'
import { userInfoAtom } from '@/modules/user'
import { removeHtmlTag } from '@/utils/remove-html-tag'

import { Customer, OverseaRegion } from '../customer.schema'
import { FieldChangedReasonFormItem } from './customer-field-change-reason.component'

export const CustomerDeliveryForm: React.FC<{
  customer?: Customer
  admins: {
    oversea: string[]
    china: string[]
  }
  fieldsChanged: {
    expectTime: boolean
  }
}> = ({ customer, admins, fieldsChanged }) => {
  const { t } = useTranslation()

  const [user] = useAtom(userInfoAtom)

  const isAdmin =
    customer &&
    (customer?.region === OverseaRegion ? admins.oversea.includes(user.email) : admins.china.includes(user.email))

  const canEditSpecialField = !customer || isAdmin || user.isSuperAdmin

  return (
    <>
      <Form.Item
        valuePropName='content'
        label={t('customer.detail.goal')}
        name='goal'
        trigger='onChange'
        rules={[
          {
            required: true,
            validator: async (_, value) =>
              !removeHtmlTag(value).trim()
                ? Promise.reject(`${t('customer.detail.goal')}是必选填项!`)
                : Promise.resolve(),
          },
        ]}
      >
        <Editor
          editable={canEditSpecialField}
          className={cls('editorBorder', { editorDisabled: !canEditSpecialField })}
          disableAutoSaveStyle
        />
      </Form.Item>
      <FieldChangedReasonFormItem field='goal' customer={customer} fieldsChanged={fieldsChanged} />

      <Form.Item label={t('customer.detail.expectTime')} name='expectTime' rules={[{ required: true }]}>
        <DatePicker disabled={!canEditSpecialField} />
      </Form.Item>
      <FieldChangedReasonFormItem field='expectTime' customer={customer} fieldsChanged={fieldsChanged} />

      <Form.Item
        valuePropName='content'
        label={t('customer.detail.standard')}
        name='standard'
        trigger='onChange'
        rules={[
          {
            required: true,
            validator: async (_, value) =>
              !removeHtmlTag(value).trim()
                ? Promise.reject(`${t('customer.detail.standard')}是必选填项!`)
                : Promise.resolve(),
          },
        ]}
      >
        <Editor
          editable={canEditSpecialField}
          className={cls('editorBorder', { editorDisabled: !canEditSpecialField })}
          disableAutoSaveStyle
        />
      </Form.Item>
      <FieldChangedReasonFormItem field='standard' customer={customer} fieldsChanged={fieldsChanged} />
    </>
  )
}
